import React, { forwardRef } from "react";
import { useQuery } from "@apollo/client";
import { SKILL_TYPE_MANY } from "../../../schema/skillType";
import { SkillType } from "../../../types";

import { Loading, Error } from "../../ui/Alerts";

const SkillTypeSelect = forwardRef((props: any, ref: any) => {
  const { loading, error, data } = useQuery(SKILL_TYPE_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <select
      {...props}
      ref={ref}
      autoComplete="type"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
    >
      <option value=""></option>
      {data.skillTypeMany.map((skillType: SkillType) => (
        <option key={skillType._id} value={skillType._id}>
          {skillType.name}
        </option>
      ))}
    </select>
  );
});

export default SkillTypeSelect;
